import { render, staticRenderFns } from "./dest-selector.vue?vue&type=template&id=622044de"
import script from "./dest-selector.vue?vue&type=script&lang=js"
export * from "./dest-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports